import { Injectable } from '@angular/core';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class CustomHttpInterceptorInterceptor implements HttpInterceptor
{

  constructor(
    private cookie_s: CookieService
  ) {}

  intercept( request: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>>
  {

    if (request.url.startsWith(environment.api_url))
    {
      if ( this.cookie_s.get('token') )
      {
        request = request.clone({
          headers: request.headers
            .set('authorization', 'bearer ' + this.cookie_s.get('token'))
            .set('lang', this.cookie_s.get('lang') || 'en'),
        });

      }
      else
      {
        request = request.clone({
          headers: request.headers.set('lang', this.cookie_s.get('lang') || 'en'),
        });
      }
    }
console.log("in first intercept")
    return next.handle(request);

  }



}
